import { AlpineComponent, AlpineStore, ComponentStores } from 'alpinejs';

import {
  alpineComponent,
  alpineStore,
} from '@/src/utilities/component-utilities';

export const navComponent = alpineComponent<NavComponent, NavStores>(
  'nav',
  () =>
    ({
      menuOpen: false,
      searchOpen: false,
      alertVisible: true,

      init() {
        const onOpen = () => {
          this.$store.overlay.show =
            (this.menuOpen && window.innerWidth < 1024) || this.searchOpen;
        };
        this.$watch('menuOpen', onOpen);
        this.$watch('searchOpen', onOpen);

        const alertCookie = sessionStorage.getItem('global_alert');
        const globalAlert = document.querySelector('.global-alert');

        if (alertCookie === 'alert_closed') {
          globalAlert?.classList.add('hidden');
        }

        this.$watch('alertVisible', onOpen);
      },

      toggleMenu() {
        this.menuOpen = !this.menuOpen;

        if (this.menuOpen) {
          if (window.innerWidth < 1024) {
            const globalAlert = document.querySelector('.global-alert');
            if (globalAlert) {
              globalAlert.classList.add('hidden');
            }
          }
        } else {
          if (window.innerWidth < 1024) {
            const globalAlert = document.querySelector('.global-alert');
            if (globalAlert) {
              globalAlert.classList.remove('hidden');
            }
          }
        }
      },

      toggleSearch() {
        this.searchOpen = !this.searchOpen;

        if (this.searchOpen) {
          const inputFocus = document.getElementById('site-search');
          inputFocus?.focus();

          if (window.innerWidth < 1024) {
            const globalAlert = document.querySelector('.global-alert');
            if (globalAlert) {
              globalAlert.classList.add('hidden');
            }
          }
        } else {
          if (window.innerWidth < 1024) {
            const globalAlert = document.querySelector('.global-alert');
            if (globalAlert) {
              globalAlert.classList.remove('hidden');
            }
          }
        }
      },
      closeAlert() {
        const globalAlert = document.querySelector('.global-alert');
        this.alertVisible = false;
        sessionStorage.setItem('global_alert', 'alert_closed');
        globalAlert?.remove();
      },
    } as NavComponent)
);

export const overlayStore = alpineStore<OverlayStore>('overlay', {
  show: false,
});

interface NavComponent extends AlpineComponent<NavStores> {
  menuOpen: boolean;
  searchOpen: boolean;
  alertVisible: boolean;

  toggleMenu(): void;
  toggleSearch(): void;
  closeAlert(): void;
}

interface OverlayStore extends AlpineStore {
  show: boolean;
}

interface NavStores extends ComponentStores {
  overlay: OverlayStore;
}
